import {Vue} from "ui.vue";
import 'citrus.vue.vue-form.fields';

import "./flatpickr/flatpickr.js";
import "./flatpickr/ru.js";

import "./style.scss";

import CitrusDatePick from "./components/base.vue";
import CitrusBirthdayDate from "./components/BirthdayDate.vue";
import CitrusAdminDate from "./components/AdminDate.vue";

Vue.cloneComponent('CitrusDatePick', 'FormFieldText', CitrusDatePick);
Vue.cloneComponent('CitrusBirthdayDate', 'CitrusDatePick', CitrusBirthdayDate);
Vue.cloneComponent('CitrusAdminDate', 'CitrusDatePick', CitrusAdminDate);
